/* Flechas de la galería de las tarjetas de producto.
   Se usa delegación en document a propósito: las tarjetas se añaden también por
   JS (scroll infinito, filtros, vistos recientemente) y así funcionan sin
   necesidad de reinicializar nada. */
(function () {
  if (window.__mfsCardGallery) return;
  window.__mfsCardGallery = true;

  function trackOf(arrow) {
    var figure = arrow.closest('.product-card__figure');
    return figure ? figure.querySelector('.product-card__media') : null;
  }

  function refresh(track) {
    var figure = track.closest('.product-card__figure');
    if (!figure) return;
    var prev = figure.querySelector('.pc-arrow--prev');
    var next = figure.querySelector('.pc-arrow--next');
    var max = track.scrollWidth - track.clientWidth;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest && event.target.closest('.pc-arrow');
    if (!arrow) return;

    // La flecha vive dentro de la tarjeta, que es un enlace: sin esto se navegaría
    event.preventDefault();
    event.stopPropagation();

    var track = trackOf(arrow);
    if (!track) return;

    var step = track.clientWidth;
    track.scrollBy({ left: arrow.classList.contains('pc-arrow--next') ? step : -step, behavior: 'smooth' });
  });

  // Estado inicial y al desplazar, para apagar la flecha en los extremos
  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (track && track.classList && track.classList.contains('product-card__media')) refresh(track);
  }, true);

  function refreshAll() {
    document.querySelectorAll('.product-card__media').forEach(refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll, { once: true });
  } else {
    refreshAll();
  }

  document.addEventListener('infinite-scroll:loaded', refreshAll);
})();
